var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"BaseButton",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }